<template>
	<div class="ht-profile-user-bids">
		<Loading :active.sync="loading"></Loading>
		<b-table :data="bids" hoverable paginated per-page="10">
			<template slot-scope="props">
				<b-table-column field="id" :label="$t('SKU')">
					{{ props.row.Product.sku }}
				</b-table-column>
				<b-table-column field="name" :label="$t('Product name')">
					<a v-bind:href="'/product/' + props.row.id" target="_blank">{{ props.row.Product.name }}</a>
				</b-table-column>
				<b-table-column field="winner_id" :label="$t('Status')">
					<span v-if="(0 < time.diff(props.row.finish))">{{ props.row.winner_id ? $t('Sold') : $t('Not Sold')}}</span>
					<span v-else>{{ $t('in progress') }}</span>
				</b-table-column>
				<b-table-column field="price" :numeric="true" :label="$t('Buyout price')">
					<span v-if="props.row.winner_id">{{ props.row.price | toUserCurrency($data._this) }}</span>
					<span v-else>-</span>
				</b-table-column>
				<b-table-column field="price_with_commission" :numeric="true" :label="$t('Price (minus commission)')">
					<span v-if="props.row.winner_id">{{
						Math.ceil(props.row.price - (props.row.price * commission)) | toUserCurrency($data._this)
					}}</span>
					<span v-else>-</span>
				</b-table-column>
			</template>
			<template slot="footer">
				<td colspan="3">
					<span class="has-text-left">
						<h2 class="subtitle is-marginless has-text-danger">
							{{ $t('Amount') }}:&nbsp;{{ total_with_commission | toUserCurrency($data._this) }}
						</h2>
						<p class="has-text-danger">{{ $t("Reduced by the submitter's commission") }} ({{ commission * 100 }}%) </p>
					</span>
				</td>
				<td class="has-text-right">
					<strong>{{ total | toUserCurrency($data._this) }}</strong>
				</td>
				<td class="has-text-right">
					<strong>{{ total_with_commission | toUserCurrency($data._this) }}</strong>
				</td>
			</template>
		</b-table>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay'

export default {
	components: {
		Loading,
	},
	data() {
		return {
			loading: true,
			bids: [],
			showDetailsIcon: null,
			commission: 0,
			total: 0,
			total_with_commission: 0,
			total_all: 0,
			time: this.$moment(),
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
		}
	},
	props: {
		selectAuction: null,
		selectedTab: null,
		seller: {
			type: Boolean,
			default: false
		},
		winner: {
			type: Boolean,
			default: false
		},
		refresh: null,
	},
	mounted() {
		this.fetchList()
	},
	methods: {
		total_price: function (rows, _this) {
			_this.total = 0
			_this.total_with_commission = 0
			_this.total_all = 0
			Object.entries(rows).forEach(([value, index]) => {
				if (index.winner_id) {
					_this.total_with_commission += Math.ceil(index.price - (index.price * _this.commission))
					_this.total += index.price
				}
			})
		},
		fetchList: function () {
			var _this = this
			_this.loading = true
			var path = '/selling-bids/' + _this.selectAuction
			_this.$http.get(path).then((response) => {
				if (response.data.sellingbids.length > 0) {
					_this.bids = response.data.sellingbids
					_this.commission = response.data.commission
				}
				_this.loading = false
			})
		},
	},
	watch: {
		selectedTab: function (newVal) {
			if (newVal == 2) {
				this.fetchList()
			}
		},
		selectAuction: function () {
			this.fetchList()
		},
		bids: function (newVal) {
			this.total_price(newVal, this)
			this.checkedRows = []
		},
		refresh: function () {
			if (this.selectedTab == 2) {
				this.fetchList()
			}
		},
	},
}
</script>
